import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import LoggerClient from '../client/LoggerClient';
import cacheInstance from '../cache/LoggingCache';
import { CACHE_DEDUPLICATION_THRESHOLD_MILLISECONDS, CACHE_ENABLED, CACHE_DEDUPLICATION_TIME_MILLISECONDS, CACHE_SIZE } from '../constants/loggingConstants';
import LoggingUtil from '../common/LoggingUtil';

var LoggerService = /*#__PURE__*/function () {
  function LoggerService() {
    _classCallCheck(this, LoggerService);
  }

  _createClass(LoggerService, null, [{
    key: "sendLogEvent",
    value: function sendLogEvent(config, logPayload) {
      var debugEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var cacheEnabled = LoggingUtil.get(config, CACHE_ENABLED, true);

      if (cacheEnabled) {
        LoggerService._handleSendLogEventWhenCacheEnabled(config, logPayload, debugEnabled);
      } else {
        LoggerService._handleSendLogEventWhenCacheDisabled(config, logPayload, debugEnabled);
      }
    }
  }, {
    key: "_handleSendLogEventWhenCacheDisabled",
    value: function _handleSendLogEventWhenCacheDisabled(config, logPayload, debugEnabled) {
      LoggerClient.post(config, LoggerService._appendPayloadData(config, logPayload), debugEnabled);
    }
  }, {
    key: "_handleSendLogEventWhenCacheEnabled",
    value: function _handleSendLogEventWhenCacheEnabled(config, logPayload, debugEnabled) {
      return LoggerService._getHashedMessage(logPayload.logEvent.description).then(function (hashedDescription) {
        var lruCache = LoggerService._getCache(config);

        if (!lruCache.has(hashedDescription)) {
          lruCache.set(hashedDescription, Date.now());
          LoggerClient.post(config, LoggerService._appendPayloadData(config, logPayload), debugEnabled);
          return;
        }

        var cacheDeduplicateThresholdMilliseconds = LoggingUtil.get(config, CACHE_DEDUPLICATION_TIME_MILLISECONDS, CACHE_DEDUPLICATION_THRESHOLD_MILLISECONDS);

        if (LoggerService._shouldSendLogEvent(cacheDeduplicateThresholdMilliseconds, hashedDescription)) {
          LoggerClient.post(config, LoggerService._appendPayloadData(config, logPayload), debugEnabled);
        } else if (debugEnabled) {
          // eslint-disable-next-line no-console
          console.debug("Log event with description: ".concat(logPayload.logEvent.description, " occurred before set deduplication threshold value of: ").concat(cacheDeduplicateThresholdMilliseconds, " milliseconds"));
        }

        lruCache.set(hashedDescription, Date.now());
      });
    }
  }, {
    key: "_shouldSendLogEvent",
    value: function _shouldSendLogEvent(cacheDeduplicateThresholdMilliseconds, hashedDescription) {
      var lruCache = LoggerService._getCache();

      var existingTimestamp = lruCache.get(hashedDescription);
      var currentTimeStamp = Date.now();
      return currentTimeStamp - existingTimestamp > cacheDeduplicateThresholdMilliseconds;
    }
  }, {
    key: "_getCache",
    value: function _getCache(config) {
      var cacheSize = LoggingUtil.get(config, CACHE_SIZE, undefined);

      if (cacheSize) {
        cacheInstance.setCacheSize(cacheSize);
      }

      return cacheInstance.getCache();
    }
  }, {
    key: "_appendPayloadData",
    value: function _appendPayloadData(config, logPayload) {
      var newMsgPayload = Object.assign({}, logPayload);
      newMsgPayload.applicationId = "".concat(config.appName, ", ").concat(config.appVersion);
      newMsgPayload.eventTimestamp = new Date().toUTCString();
      newMsgPayload.codeLocation = LoggerService._getCallerLocation();
      return newMsgPayload;
    }
  }, {
    key: "_getHashedMessage",
    value: function () {
      var _getHashedMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(description) {
        var hashedValue, hashArray;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return window.crypto.subtle.digest('SHA-512', this._str2ab(description));

              case 2:
                hashedValue = _context.sent;
                hashArray = Array.from(new Uint8Array(hashedValue)); // convert buffer to byte array

                return _context.abrupt("return", hashArray.map(function (b) {
                  return b.toString(16).padStart(2, '0');
                }).join(''));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getHashedMessage(_x) {
        return _getHashedMessage2.apply(this, arguments);
      }

      return _getHashedMessage;
    }()
  }, {
    key: "_str2ab",
    value: function _str2ab(str) {
      var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char

      var bufView = new Uint8Array(buf);

      for (var i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
      }

      return buf;
    }
  }, {
    key: "_getCallerLocation",
    value: function _getCallerLocation() {
      var stackTrace = '';

      try {
        throw new Error('at LoggerService.js:fake exception:');
      } catch (e) {
        stackTrace = e.stack;
      }

      var stackArray = stackTrace.split('at ');

      for (var i = 1; i < stackArray.length; i++) {
        var stackArrayItem = stackArray[i];
        var isAppFabricFile = stackArrayItem.includes('LoggerService.js') || stackArrayItem.includes('LoggerFactory.js');

        if (!isAppFabricFile) {
          return stackArrayItem;
        }
      }

      return '';
    }
  }]);

  return LoggerService;
}();

export { LoggerService as default };